<template>
    <avue-crud
            :option="option"
            :data="data"
            :page="page"
            @refresh-change="refreshChange"
            @search-change="searchChange"
            @row-save="store"
            @row-update="update"
            @row-del="del"
            @size-change="sizeChange"
            @current-change="currentChange"
            :upload-before="uploadBefore"
            ref="crud"
    >
        <template slot="menuLeft">
            <el-button size="small" icon="el-icon-download" type="success" @click="excelExport('宿舍申请', '用户、所属部门、工号、电话、性别、申请类型、申请内容、申请时间、是否回复、回复内容、回复时间')">导出Excel</el-button>
        </template>
        <template slot-scope="scope" slot="menu">
            <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.is_reply===1" @click.stop="handleReply(scope.row,scope.index)">回复</el-button>
        </template>

        <template slot-scope="scope" slot="is_reply">
            <span v-if="scope.row.is_reply===1" style="color: crimson">未回复</span>
            <span v-if="scope.row.is_reply===2" style="color: green">已回复</span>
        </template>
    </avue-crud>
</template>
<script>
  import curd from './Base/Crud'

  export default {
    mixins: [curd],
    data() {
      return {
        // curd组件
        option: {
          viewBtn: true, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText:'新增活动', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '申请内容',
              overHidden: true,
              editDisplay: false,
              align: 'left',
              prop: 'content',
              span: 24,
            }, {
              label: '申请人',
              editDisplay: false,
              prop: 'user-username'
            },
            {
              label: '所属部门',
              prop: 'user-class',
              span: 24,
            },
            {
              label: '申请类型',
              prop: 'type',
              editDisplay: false,
              type: 'select',
              search: true,
              // slot: true,
              dicUrl: this.getDic('affair.hostel_type'),
            }, {
              label: '性别',
              editDisplay: false,
              prop: 'sex',
              type: 'select',
              dicUrl: this.getDic('sex'),
            }, {
              label: '原因',
              editDisplay: false,
              span: 24,
              prop: 'reason'
            }, {
              label: '是否回复',
              prop: 'is_reply',
              editDisplay: false,
              search: true,
              type: 'select',
              slot: true,
              dicUrl: this.getDic('is_reply'),
            }, {
              label: '回复内容',
              prop: 'reply',
              overHidden: true,
              span: 24
            }, {
              label: '回复时间',
              prop: 'reply_time',
              editDisplay: false
            }
          ]
        }
      }
    },
    methods: {
      // 回复
      handleReply (row, index) {
        this.$refs.crud.rowEdit(row, index)
      }
    }
  }
</script>
